import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type SyncWorkoutVariables = {
  workoutId: number;
};

export const useSyncWorkout = () => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workoutId }: SyncWorkoutVariables) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/workouts/${workoutId}/sync`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error('Unable to resync this activity.');
      }

      return response.text();
    },
    onSuccess: async (_data, { workoutId }) => {
      await queryClient.invalidateQueries({
        queryKey: ['workout', String(workoutId)],
      });
      await queryClient.invalidateQueries({ queryKey: ['workouts'] });
    },
  });
};
